import { getCookies } from "../../../helpers/storage";

const CleartaxIframe = () => {
  const accessToken = getCookies("accessToken");
  const baseUrl = process.env.REACT_APP_CLEARTAX_URL;
  const cleartaxUrl = `${baseUrl}?token=${accessToken}`;

  return (
    <div>
      {
        <iframe
          src={cleartaxUrl}
          style={{ width: "100%", height: "100vh", border: "none" }}
          title="ClearTax Partner"
        />
      }
    </div>
  );
};

export default CleartaxIframe;
